import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-save-draft-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule],
  templateUrl: './save-draft-dialog.component.html',
  styleUrl: './save-draft-dialog.component.css'
})
export class SaveDraftDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<SaveDraftDialogComponent>) {}

  //  @Inject(MAT_DIALOG_DATA) public data: { mode: 'draft' | 'warn' }
  close(result: 'yes' | 'no' | 'cancel') {
    this.dialogRef.close(result);
  }
}
